import { Translation } from "./Translation";

export const de: Translation = {
    Strings: {
        PropertyPaneDescription: "Konfigurieren Sie die Namen der Request-Parameter",
        PropertyPaneBasicGroupName: "Request Parameter Namen",
        PropertyPaneVersionUrlParameter: "Document Version",
        PropertyPaneMgmtItemIdUrlParameter: "Management Item ID",

        StatusText_ActiveDoc: "Dieses Dokument ist aktuell!",
        StatusText_InactiveDoc: "Dies ist nicht das aktuellste Dokument!",

        MostCurrentVersionInfoText_Part1: "Das angefragte Dokument is in Version ",
        MostCurrentVersionInfoText_Part2: ", aber die aktuellste Version ist ",

        OpenDocumentInBrowser: "Dokument im Browser öffnen",
        DownloadDocument: "Download",
        OpenFolderInBrowser: "Verzeichnis im Browser öffnen",

        OpenMostCurrentVersionInBrowser: "Aktuellste Version im Browser öffnen",
        DownloadMostCurrentVersion: "Aktuellste Version herunterladen",
        OpenRequestedDocumentVersion: "Angefragte Version des Dokuments öffnen",
        VersionDoesNotExist1: "Die Version ",
        VersionDoesNotExist2: ".0 existiert nicht!",
    }
}